<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="shadow-lg">
          <div class="row content-add-btn">
            <button class="btn btn-secondary" @click="$router.go(-1)">
              <em class="fa fa-chevron-left"></em>
              {{ $t('common_words.exit') }}
            </button>
          </div>
          <hr />
          <form
            @submit.prevent="validateForm"
            v-if="this.isCreate() || this.isUpdate()"
          >
            <div class="row">
              <div class="col-md-6">
                <fg-input
                  type="text"
                  :label="`${$t('common_words.name')}*`"
                  v-model="moduleForm.name"
                  name="common_words.name"
                  v-validate="modelValidations.nombre"
                  :error="getError('common_words.name', true)"
                  :placeholder="`${$t('common_words.name')}...`"
                >
                </fg-input>
              </div>
              <div class="col-md-6">
                <div class="form-group has-label">
                  <label> {{ $t('common_words.type_of_module') }}*</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required shadow-sm"
                    size="large"
                    v-model="moduleForm.module_type"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in moduleTypes"
                      class="select-primary"
                      :value="option"
                      :label="option"
                      :key="index"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fg-input
                  type="text"
                  label="URL *"
                  v-model="moduleForm.url"
                  name="url"
                  v-validate="modelValidations.url"
                  placeholder="/ulr/example..."
                  :error="getError('url')"
                >
                </fg-input>
              </div>
              <div class="col-md-6">
                <div class="form-group has-label">
                  <label>{{ $t('common_words.parent_module') }}</label>
                  <br />
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    v-model="moduleForm.parent_module"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      :value="0"
                      :label="$t('common_words.none')"
                    ></el-option>
                    <el-option
                      v-for="option in modules"
                      class="select-primary"
                      :value="option.id"
                      :label="option.id + ' - ' + option.name"
                      :key="option.id + ' - ' + option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div
              class="row"
              v-if="
                moduleForm.module_type == 'movil' ||
                moduleForm.module_type == 'both'
              "
            >
              <div class="col-md-6">
                <p>
                  {{ $t('common_words.module_mobile_info') }}
                </p>
                <fg-input
                  type="text"
                  :label="$t('common_words.mobile_id')"
                  v-model="moduleForm.movil_id"
                >
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label>{{ $t('common_words.level') }} *</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required shadow-sm"
                  size="large"
                  v-model="moduleForm.level"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in levels"
                    class="select-primary"
                    :value="option.id"
                    :label="option.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>

              <div class="col-md-2">
                <label>{{ $t('common_words.order_request') }}</label>
                <fg-input
                  v-bind:min="0"
                  type="number"
                  v-model="moduleForm.order"
                  name="common_words.order_request"
                  v-validate="modelValidations.order"
                  :error="getError('common_words.order_request', true)"
                >
                </fg-input>
              </div>
              <div class="col-md-2">
                <fg-input
                  type="text"
                  :label="`${$t('common_words.icon')}*`"
                  v-model="moduleForm.icon"
                  name="common_words.icon"
                  v-validate="modelValidations.icono"
                  :error="getError('common_words.icon', true)"
                  :placeholder="`${$t('common_words.icon')}...`"
                >
                </fg-input>
              </div>
              <select-component
                :rowClass="`col-3`"
                :labelSelect="`${$t('common_words.select_crops')}`"
                :dataOptions="crops"
                :initialSelection="moduleForm.crop_ids"
                @onChange="handleChangeSelected"
                modelName="crop_ids"
              />
              <div class="col-3">
                <span style="font-size: 16px" class="text-muted">
                  {{ $t('common_words.manuals') }}:
                </span>
                <el-upload
                  multiple
                  ref="uploadManuals"
                  :action="getAxiosURL() + '/auth/modules/uploadmanual'"
                  :data="uploadData"
                  :headers="headerInfo"
                  :limit="1"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :on-success="handleSuccess"
                  :file-list="fileListManuals"
                  :auto-upload="false"
                  accept=".pdf"
                >
                  <el-button size="small mt-1" type="primary">{{
                    $t('common_words.click_to_load')
                  }}</el-button>
                  <div slot="tip" class="mt-2 el-upload__tip">
                    {{ $t('common_words.file_size_limit_fivemb') }}
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group has-label">
                  <label>{{ $t('common_words.description') }}</label>
                  <br />
                  <el-input
                    maxlength="300"
                    show-word-limit
                    type="textarea"
                    :rows="3"
                    :placeholder="`${$t('common_words.manage')}...`"
                    v-model="moduleForm.description"
                    name="common_words.description"
                    v-validate="modelValidations.descripcion"
                    :error="getError('common_words.description', true)"
                    class="shadow-sm"
                  ></el-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group has-label">
                  <label
                    >{{
                      $t('common_words.select_associated_modules_companies')
                    }}
                  </label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect(
                        'moduleForm.businesses_id',
                        businesses
                      )
                    "
                    clearable
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    v-model="moduleForm.businesses_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="option in businesses"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group has-label">
                  <label>{{
                    $t('common_words.select_associated_module_profiles_inputed')
                  }}</label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('moduleForm.roles', roles)"
                    clearable
                    multiple
                    filterable
                    class="select-primary custom-width-select shadow-sm"
                    size="large"
                    v-model="moduleForm.roles"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="option in roles"
                      class="select-primary selected-all"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label style="margin-bottom: 15px">{{
                  $t('common_words.own_permissions')
                }}</label>
                <el-checkbox
                  class="ml-4"
                  size="medium"
                  v-model="moduleForm.defaultPermissions"
                  >{{ $t('common_words.assign_default_permissions') }}(<b>
                    {{ $t('common_words.crud') }}</b
                  >).</el-checkbox
                >
                <br />
                <el-tag
                  :key="tag"
                  v-for="tag in moduleForm.own_permissions"
                  closable
                  type="info"
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{ tag }}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="input_own_permissions"
                  ref="saveTagInput"
                  size=""
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button
                  v-tooltip.top-center="$t('common_words.add_permit')"
                  v-else
                  class="btn-secondary button-new-tag"
                  size="small"
                  @click="showInput"
                  icon="el-icon-plus"
                >
                </el-button>
              </div>
            </div>
            <hr />
            <br />
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-fill btn-info btn-wd shadow-sm"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
          </form>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_operations') }}
            </h5>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ChartCard,
  StatsCard,
  Card,
  Table as LTable,
  Checkbox,
} from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { showContinue } from 'src/util/Util.js';
import i18n from '../../../../i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    Checkbox,
    Card,
    LTable,
    ChartCard,
    StatsCard,
  },

  data() {
    return {
      title: '',
      modelCopy: {},
      fileListManuals: [],
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
        locale: this.$i18n.locale,
      },
      uploadData: {
        user: this.$store.state.auth.user.id,
        urlModule: null,
      },
      moduleForm: {
        defaultPermissions: true,
        name: null,
        url: null,
        oldUrl: null,
        icon: null,
        description: null,
        order: 0,
        level: null,
        videoUrl: null,
        manuals: null,
        caseOfUse: null,
        parent_module: 0,
        roles: [],
        own_permissions: [],
        module_type: null,
        businesses_id: [],
        crop_ids: [],
        fileListManuals: [],
        manualPath: null,
      },
      modelValidations: {
        nombre: {
          required: true,
        },
        url: {
          required: true,
        },
        icono: {
          required: true,
        },
        order: {
          required: this.isUpdate() && this.isEditForm() ? true : false,
        },
        nivel: {
          required: true,
        },
        padre: {
          required: true,
        },
      },
      inputVisible: false,
      input_own_permissions: '',
      roles: null,
      modules: [],
      businesses: [],
      crops: [],
      moduleTypes: ['web', 'movil', 'both', 'google'],
      levels: [
        { id: 1, label: '- Nivel 1' },
        { id: 2, label: '-- Nivel 2' },
        { id: 3, label: '--- Nivel 3' },
      ],
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinForm, MixinMenu],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
      this.roles = this.concatAll(this.businesses.splice(1));
    },

    handleChangeSelected(data) {
      this.$set(this.moduleForm, data.name, data.selects);
    },

    handleClose(tag) {
      this.moduleForm.own_permissions.splice(
        this.moduleForm.own_permissions.indexOf(tag),
        1
      );
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.input_own_permissions.trim();
      if (
        inputValue &&
        !['index', 'store', 'update', 'destroy'].includes(inputValue)
      ) {
        this.moduleForm.own_permissions.push(inputValue);
      }
      this.inputVisible = false;
      this.input_own_permissions = '';
    },

    validateForm(name) {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          return store
            .dispatch('utils/validationInputsRequired', '')
            .then((resp) => {
              if (resp) {
                this.uploadData.urlModule = this.moduleForm.url;

                this.$refs.uploadManuals.submit();
                this.storeUpdateModule();
                this.fileListManuals = [];
                this.fileListCaseOfUse = [];
              }
            });
        }
      });
    },

    isEditForm() {
      return sessionStorage.getItem('editForm');
    },

    storeUpdateModule() {
      this.showHideLoading(true);
      this.moduleForm.route = 'modules';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.moduleForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.moduleForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/modules',
                null,
                false
              ).then((result) => {
                if (result.value) {
                  this.moduleForm = this.modelCopy;
                  this.modelCopy = { ...this.moduleForm };
                }
              });
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.moduleForm)
            .then((response) => {
              this.showHideLoading();
              this.forceRenderMenu();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/modules',
                null,
                false
              ).then((result) => {
                if (result.value) {
                  this.moduleForm = this.modelCopy;
                  this.modelCopy = { ...this.moduleForm };
                }
              });
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    handleRemove(file, fileListManuals) {
      if (this.moduleForm.manualPath) {
        const dataRemove = {
          route: 'modules/deletemanual', //ruta para eliminar
          manualPath: this.moduleForm.manualPath,
          fileName: file.name,
        };
        Axios.postMasters(dataRemove)
          .then()
          .catch((error) => {
            this.showMessageErrors(error);
          });
      }
      this.fileListManuals = fileListManuals;
      this.moduleForm.fileListManuals = fileListManuals.map(
        (file) => file.name
      );
    },

    handleExceed(_, fileListManuals) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.common.the_limit')} ${
          this.$refs.uploadManuals.limit
        },
        ${i18n.t('sweet_alert.common.already_selected')} ${
          fileListManuals.length
        } ${i18n.t('sweet_alert.common.files')}`
      );
    },

    handleSuccess(response) {
      if (response.error) {
        SweetAlert.warning(response.error);
      }
    },

    handleChange(file, fileListManuals) {
      const maxSizeInKB = 20000;
      const isSizeValid = file.size / 1024 > maxSizeInKB;
      if (isSizeValid) {
        SweetAlert.warning(i18n.t('sweet_alert.common.maximum_size_per_file'));
        this.$refs.uploadCertificationEvidence.uploadFiles.pop();
      }
      this.fileListManuals = fileListManuals;
      this.moduleForm.fileListManuals = fileListManuals.map(
        (file) => file.name
      );
      this.moduleForm.manualPath = this.moduleForm.url;
    },
  },

  created() {
    this.modelCopy = { ...this.moduleForm };
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);
          let editForm = {};
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            this.title = i18n.t('common_words.edit_module');
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.moduleForm.name = editForm.name;
            this.moduleForm.url = editForm.url;
            this.moduleForm.oldUrl = editForm.url;
            this.moduleForm.order = editForm.order;
            this.moduleForm.level = editForm.level;
            this.moduleForm.parent_module = editForm.parent_module;
            this.moduleForm.description = editForm.description;
            this.moduleForm.module_type = editForm.module_type;
            this.moduleForm.movil_id = editForm.movil_id;
            this.moduleForm.businesses_id = editForm.businesses_id;
            this.moduleForm.roles = editForm.roles_ids;
            this.moduleForm.own_permissions = editForm.own_permissions;
            this.moduleForm.icon = editForm.icon;
            this.moduleForm.manualPath = editForm.manual_path;

            if (isset(editForm.crops)) {
              this.moduleForm.crop_ids = editForm.crops.map((item) => item.id);
            }

            if (isset(editForm.manual_path)) {
              this.fileListManuals = editForm.fileList.map((value) => ({
                name: value,
              }));
            }
          }

          if (!sessionStorage.getItem('editForm')) {
            this.moduleForm.businesses_id = this.selectElementsAsignFromModel(
              1,
              this.moduleForm.businesses_id,
              this.businesses
            );

            if (
              this.moduleForm.businesses_id === null &&
              this.businesses.length == 1
            ) {
              this.moduleForm.businesses_id.push(this.businesses[0].id);
            }
          }

          Axios.getMasters('roles/indexfield')
            .then((response1) => {
              this.roles = this.concatAll(response1.data.data);
              this.title = i18n.t('common_words.add_module');

              if (!sessionStorage.getItem('editForm') && this.roles.length == 1)
                this.moduleForm.roles.push(this.roles[0].id);

              Axios.getMasters('modules/indexfield')
                .then((response2) => {
                  this.modules = response2.data.data;
                  this.showHideLoading();
                })
                .catch((error) => {
                  this.showHideLoading();
                  SweetAlert.warning(error.response.data.message);
                });
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });

          Axios.getMasters('farms/crops')
            .then((response) => {
              this.crops = this.concatAll(response.data.data);
              this.showHideLoading();
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('modules');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('modules');
  },
};
</script>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 300px !important;
  margin-left: 10px;
}

.input-new-tag .el-input__inner {
  height: 33px !important;
  line-height: 33px !important;
}
</style>
